module.exports = __webpack_public_path__ + "img/history.87f6856a.png";